import { showErrorNotification } from "../components/admin/common/NotiService"
import { DEFAULT_HISTORIC_REPORT_ID_MAP, DEFAULT_LIVE_REPORT_ID_MAP, HISTORIC_REPORTS_LIST, HISTORIC_REPORTS_LIST_ROLES_ID_MAP, HISTORIC_REPORTS_LIST_RULES_ID_MAP, LIVE_REPORTS_LIST, LIVE_REPORTS_LIST_ROLES_ID_MAP, LIVE_REPORTS_LIST_RULES_ID_MAP } from "../utils/constants"
import { LOCATION } from "../utils/properties"
import { checkCustomCDR, checkRoles, checkSettings, generateFourLetterRandomString } from "../utils/util"
import { getSettingsListByCode, getUserLoggedIn, getUserModules } from "./api-service"
import { cacheSlashcallSuperAdminEmail, setRoleData, setUserEmail } from "./auth-service"

export const AdminPages = {
    //campaigns
    INBOUND_CAMP_VIEW: 'inboundCampaignsView',
    INBOUND_CAMP_EDIT: 'inboundCampaignsEdit',
    OUTBOUND_CAMP_VIEW: 'outboundCampaignsView',
    OUTBOUND_CAMP_EDIT: 'outboundCampaignsEdit',
    MARKETING_CAMP_VIEW: 'marketingCampaignsView',
    MARKETING_CAMP_EDIT: 'marketingCampaignsEdit',
    RESTORE_CAMP_VIEW: 'restoreCampaignsView',

    //Templates //SMS templates in old is same as all templates
    // EmailTemplatePage: emailTemplatesView,
    // 'emailTemplatesEdit',
    // 'whatsappTemplatesView',
    // 'whatsappTemplatesEdit', 
    TEMPLATES_VIEW: 'templatesView',
    TEMPLATES_EDIT: 'templatesEDIT',

    // will show userlist by defaut & roles check will handle it
    USERS_VIEW: 'usersView',
    USERS_EDIT: 'usersEdit',

    //Agents
    AGENTS_VIEW: 'agentsView',
    AGENTS_EDIT: 'agentsEdit',

    //Groups
    GROUPS_VIEW: 'groupsView',
    GROUPS_EDIT: 'groupsEdit',

    //Ivr
    IVR_FLOWS_VIEW: 'IVRFlowsView',
    // IVR_FLOWS_EDIT: 'IVRFlowsEdit',

    //Manage Numbers
    AGENT_NUMBERS_VIEW: 'AgentNumbersView',
    AGENT_NUMBERS_EDIT: 'AgentNumbersEdit',
    DAILOUT_NUMBERS_VIEW: 'dailoutNumbersView',
    DAILOUT_NUMBERS_EDIT: 'dailoutNumbersEdit',
    TRANSFER_NUMBERS_VIEW: 'transferNumbersView',
    TRANSFER_NUMBERS_EDIT: 'transferNumbersEdit',
    //view and edit is same for block group numbers
    BLOCKED_NUMBERS_VIEW: 'blockedNumbersView',
    // BLOCKED_NUMBERS_EDIT: 'blockedNumbersEdit',

    //Locations
    LOCATIONS_VIEW: 'locationsView',
    LOCATIONS_EDIT: 'locationsEdit',

    //Skills
    SKILLS_VIEW: 'skillsView',
    SKILLS_EDIT: 'skillsEdit',

    //pauseReason
    PAUSE_REASONS_VIEW: 'pauseReasonsView',
    PAUSE_REASONS_EDIT: 'pauseReasonsEdit',

    //Disposition
    DISPOSITIONS_VIEW: 'dispositionsView',
    DISPOSITIONS_EDIT: 'dispositionsEdit',

    //Pre-Post Call Flow
    PREPOST_VIEW: 'prePostView',
    PREPOST_EDIT: 'prePostEdit',

    //mappings
    MAPPINGS_LIST_VIEW: 'mappingsView', //no edit for mappings

    //sipLocations
    SIPLOCATIONS_VIEW: 'SipLocationView',
    //  SIPLOCATIONS_Edit : 'SipLocationsEdit,

    // Integrations (edit and view is same for integrations)
    INTEGRATIONS_VIEW: 'integrationsView',

    //settings
    // except profile edit all the settings will be handled with this settings
    // 'adminSettingsView',
    // 'adminSettingsEdit',
    // 'agentSettingsView',
    // 'agentSettingsEdit'
    USER_SETTINGS: 'userSettings'

    // DNC will be handled with roles
}

export const NewAdminPages = {
    //campaigns
    CAMPAIGN_PAGE: 'Campaigns',
    // INBOUND_CAMP: 'Inbound Campaigns',
    // OUTBOUND_CAMP: 'Outbound Campaigns',
    // CHAT_CAMP: 'Chat Campaigns',
    // MARKETING_PAGE: 'Marketing Campaigns',
    // RESTORE_CAMP: 'Restore Campaigns',

    //agents
    AGENTS_PAGE: 'Agents',
    BULK_UPDATE: 'Bulk Update',
    // AGENTS_VIEW: 'agentsView',
    // AGENTS_EDIT: 'agentsEdit',

    //Templates
    TEMPLATES_PAGE: 'Templates',

    //Skills
    SKILLS_PAGE: 'Skills',

    //dispositions
    DISPOSITIONS_PAGE: 'Dispositions',

    //Groups
    GROUPS: 'Groups',
    // GROUPS_VIEW: 'Groups View',
    // GROUPS_EDIT: 'Groups Edit',

    //Ivr
    IVR_FLOWS: 'IVR Flows',
    IVR_SKILL_SPLIT_SELECTION: 'Volume Routing',
    // IVR_FLOWS_VIEW: 'IVRFlowsView',

    //Pre-Post Call Flow
    PREPOST_PAGE: 'Pre Post',
    // PREPOST_EDIT: 'PrePostEdit',

    //Manage Numbers
    // AGENT_NUMBERS_VIEW: 'AgentNumbersView',
    // AGENT_NUMBERS_EDIT: 'AgentNumbersEdit',
    // DAILOUT_NUMBERS_VIEW: 'DailoutNumbersView',
    // DAILOUT_NUMBERS_EDIT: 'DailoutNumbersEdit',
    // TRANSFER_NUMBERS_VIEW: 'TransferNumbersView',
    // TRANSFER_NUMBERS_EDIT: 'TransferNumbersEdit',
    // //view and edit is same for block group numbers
    // BLOCKED_NUMBERS_VIEW: 'Blocked Numbers',

    MANAGE_NUMBERS: 'Manage Numbers',
    // PLANS: 'Plans',
    // USERS: 'Users',
    SUB_USERS: 'Sub Users',
    LOCATIONS: 'Locations',
    PAUSE_REASONS: 'Pause Reasons',
    CUSTOM_TAGS: 'Custom Tags',
    SIP_LOCATION: 'Sip Location',
    MUSIC_FILE: 'Music File',
    OFFER_LANGUAGE_CONFIGURATION: 'Offer and Language Configuration',
    SIP_NUMBER: 'Sip Number',
    HOLIDAYS: 'Holidays',
    DID_ADDITION: 'DID Addition',
    // AGENT_NUMBERS: 'Agent Numbers',
    // DIALOUT_NUMBERS: 'Dial Out Number',
    // TRANSFER_NUMBERS: 'Transfer Numbers',
    // BLOCKED_NUMBERS: 'Blocked Numbers',

    REPORTS: 'Reports',
    LIVE_REPORTS: 'Live Reports',
    HISTORIC_REPORTS: 'Historic Reports',
    DASHBOARDS: 'Dashboard',


    //mappings
    MAPPING: 'Mapping',

    //Settings
    // SETTINGS: 'Settings',
    ADMIN_SETTTINGS: 'Admin Settings',
    AGENT_SETTINGS: 'Agent Settings',
    INTEGRATION_SETTINGS: 'Integration Settings',
    MANAGE_WIDGETS: 'Manage Widgets'
}

const pagesMap = {
    //campaigns
    'Campaigns-Inbound List': AdminPages.INBOUND_CAMP_VIEW,
    'Campaigns-Inbound Edit': AdminPages.INBOUND_CAMP_EDIT,
    'Campaigns-Outbound List': AdminPages.OUTBOUND_CAMP_VIEW,
    'Campaigns-Outbound Edit': AdminPages.OUTBOUND_CAMP_EDIT,
    'Marketing_Campaigns': AdminPages.MARKETING_CAMP_VIEW,
    'Marketing_Campaign_Edit': AdminPages.MARKETING_CAMP_EDIT,
    'RestoreCampaignList': AdminPages.RESTORE_CAMP_VIEW,

    //Templates
    'SMSTemplateList': AdminPages.TEMPLATES_VIEW,
    'SMSTemplateEdit': AdminPages.TEMPLATES_EDIT,

    // Users will show userlist by defaut & roles check will handle it

    'Agents-List': AdminPages.AGENTS_VIEW,
    'Agents-Edit': AdminPages.AGENTS_EDIT,

    //groups
    'groupsView': AdminPages.GROUPS_VIEW,
    'groupsEdit': AdminPages.GROUPS_EDIT,

    //ivr
    'IvrFlows-List': AdminPages.IVR_FLOWS_VIEW, //same for view and edit

    //Manage Numbers
    'PhoneNumbers-List': AdminPages.AGENT_NUMBERS_VIEW,
    'PhoneNumbers-Edit': AdminPages.AGENT_NUMBERS_EDIT,
    'DialOutNumbers_List': AdminPages.DAILOUT_NUMBERS_VIEW,
    'DialOutNumbers_Edit': AdminPages.DAILOUT_NUMBERS_EDIT,
    'TransferNumbers_List': AdminPages.TRANSFER_NUMBERS_VIEW,
    'TransferNumbers_Edit': AdminPages.TRANSFER_NUMBERS_EDIT,
    'BlockNumbersGroup-List': AdminPages.BLOCKED_NUMBERS_VIEW, //view and edit is same for block group numbers

    //Locations
    'Locations-List': AdminPages.LOCATIONS_VIEW,
    'Locations-edit': AdminPages.LOCATIONS_EDIT,

    //skills
    'Skills_List': AdminPages.SKILLS_VIEW,
    'Skills_Edit': AdminPages.SKILLS_EDIT,

    //pauseReason
    'Pause Reasons List': AdminPages.PAUSE_REASONS_VIEW,
    'Pause Reasons Edit': AdminPages.PAUSE_REASONS_EDIT,

    //Disposition
    'Dispositions List': AdminPages.DISPOSITIONS_VIEW,
    'Dispositions Edit': AdminPages.DISPOSITIONS_EDIT,

    // //AddCallWork
    // 'Add Call Work List': AdminPages.ADDCALLWORK_VIEW,
    // 'Add Call Work Edit': AdminPages.ADDCALLWORK_EDIT,

    //mappings   
    'Mappings_List': AdminPages.MAPPINGS_LIST_VIEW, //no edit for mappings

    //sipLocation
    'SipLocations': AdminPages.SIPLOCATIONS_VIEW, //same for view and edit

    //Integration
    'Integrations': AdminPages.INTEGRATIONS_VIEW, //edit and view is same for integrations

    // 'adminSettingsView',
    // 'adminSettingsEdit',
    // 'agentSettingsView',
    // 'agentSettingsEdit'
    'User Settings': AdminPages.USER_SETTINGS // except profile edit all the settings will be handled with this settings

    //DNC will be handled with roles
}


let finalPages = [AdminPages.USERS_VIEW, AdminPages.USERS_EDIT]

function formatKey(input) {
    return input.replace(/([a-z])([A-Z])/g, '$1 $2');
}

export async function pageAuthService() {
    await getUserModules().then(resp => {
        try {
            let data = resp.Data.userPage;
            let roleData = resp.Data.roles;
            setRoleData({ roles: JSON.stringify(roleData) });
            if (data.length > 0) {
                data.forEach(element => {
                    if (pagesMap[element.page_name]) {
                        if (!finalPages.includes(pagesMap[element.page_name])) {
                            finalPages.push(pagesMap[element.page_name])
                            if (element.page_name === 'Agents-List') {
                                finalPages.push(AdminPages.GROUPS_VIEW)
                            }
                            if (element.page_name === 'Agents-Edit') {
                                finalPages.push(AdminPages.GROUPS_EDIT)
                            }
                        }
                    }
                });
                localStorage.setItem('authPages', JSON.stringify(finalPages))
                // return finalPages;
            }
            else {
                // showErrorNotification('user modules list is empty....')
            }
        } catch (e) {
            // showErrorNotification('error getting user modules...', e)
        }

    }).catch((e) => {
        // showErrorNotification('failed to get user modules..login again.', e)
    })

    // getUserLoggedIn().then((resp) => {
    //     try {
    //         if (resp.Data.length > 0 || resp.Data !== null) {
    //             let data = resp.Data[0];
    //             if (data.parentUser === null || data.parentUser === undefined || data.parentUser === '') {
    //                 localStorage.setItem('parentUser', null);
    //             } else {
    //                 localStorage.setItem('parentUser', JSON.stringify(data.parentUser));
    //             }
    //         }
    //         else {
    //             showErrorNotification('user Profile list is empty....')
    //         }
    //     } catch (e) {
    //         showErrorNotification('error Profile user settings...', e)
    //     }
    // }).catch((e) => {
    //     showErrorNotification('failed to get user Profile..login again.', e)
    // });

    await getUserLoggedIn().then(resp => {
        try {
            syncLoggedInUserEmail(resp);
            let data = resp?.Data[0];//only doing for SubAdmin for testing

            if (data && typeof data === 'object') {
                localStorage.setItem('mappedAgent', data?.agentSubMap?.agentId || '');
                localStorage.setItem('mappedPhoneNumber', data?.fwpSubMap?.phoneNumber || '');
                localStorage.setItem('userKey', data?.apiKey || '');
            }

            let resultForPage = [];
            let resultAccess = [];
            let tempData = [];
            let tempData1 = [];
            if (resp?.Status === "Success" && resp?.Data?.length > 0) {
                localStorage.setItem("userTZ", data?.userTimezone);

                if (checkRoles("ROLE_ADMIN")) { //checking for SuperAdmin
                    tempData = data?.appPlanUser?.appPlan?.features;
                    localStorage.setItem('isSuperAdmin', "true");
                } else if (checkRoles("ROLE_ADMIN") === false) {//for Admin and SubAdmin
                    if (data?.parentUser === null || data?.parentUser === "null") { //for Admin
                        tempData = data?.appPlanUser?.appPlan?.features;
                    } else {// for SubAdmin
                        if (data?.appProfileUser[0]?.profileSetting) {
                            let tData = JSON.parse(data?.appProfileUser[0]?.profileSetting);
                            tempData1 = tData;
                        }
                    }
                    localStorage.setItem('isSuperAdmin', "false");
                }

                checkCustomCDR();

                if (data?.parentUser === null || data?.parentUser === undefined || data?.parentUser === 'null' || data?.parentUser === "") {
                    localStorage.setItem('parentUser', null);
                    localStorage.setItem('isAdmin', "true");
                } else {
                    localStorage.setItem('parentUser', JSON.stringify(data.parentUser));
                    localStorage.setItem('isAdmin', "false");
                }
            }
            if (tempData?.length > 0) { // For SuperAdmin or Admin
                tempData.forEach(item => {
                    resultForPage.push(`${item.name}`);
                });
            } else { // For SubAdmin
                console.log("tempData1", tempData1)
                console.log("LIVE_REPORTS_LIST", LIVE_REPORTS_LIST)
                console.log("HISTORIC_REPORTS_LIST", HISTORIC_REPORTS_LIST)
                Object.keys(tempData1).forEach(key => {
                    const value = tempData1[key];
                    console.log("key", key)
                    console.log("value", value)
                    if (key === 'liveReports' || key === 'historicReports') {
                        if (Array.isArray(value)) {
                            value.forEach(item => {
                                resultAccess.push(`${item.id}_${getAccess(key)}`);
                            });
                        }
                        if (typeof value === 'boolean') {
                            resultAccess.push(`${formatKey(key).charAt(0).toUpperCase() + formatKey(key).slice(1)}_${value}`);
                        }
                        if (key === 'liveReports') {
                            DEFAULT_LIVE_REPORT_ID_MAP.forEach(item => {
                                resultAccess.push(`${item}_${getAccess(key)}`);
                            });
                            if (resultAccess?.length > 0) {
                                resultAccess = Array.from(new Set(resultAccess));
                            }
                        } else if (key === 'historicReports') {
                            try {
                                DEFAULT_HISTORIC_REPORT_ID_MAP.forEach(item => {
                                    resultAccess.push(`${item}_${getAccess(key)}`);
                                });
                                if (resultAccess?.length > 0) {
                                    resultAccess = Array.from(new Set(resultAccess));
                                }
                            } catch (e) {
                                console.log("Error in adding default historic report access", e)
                            }
                        }
                    } else if (Array.isArray(value)) {
                        value.forEach(item => {
                            // resultAccess.push(`${item}_${key}`);
                            resultAccess.push(`${item}_${getAccess(key)}`);
                        });
                    } else if (typeof value === 'boolean') {
                        // resultAccess.push(`${(key === 'liveReports' ? 'live Reports' : key === 'historicReports' ? 'historic Reports' : key).charAt(0).toUpperCase() + (key === 'liveReports' ? 'live Reports' : key === 'historicReports' ? 'historic Reports' : key).slice(1)}_${value}`);
                        resultAccess.push(`${formatKey(key).charAt(0).toUpperCase() + formatKey(key).slice(1)}_${value}`);
                    }
                });
            }
            localStorage.setItem('newAuthPage', JSON.stringify(resultForPage));
            console.log("resultForPage", resultForPage)
            localStorage.setItem('newAuthSubAdminAccess', JSON.stringify(resultAccess));
            console.log("resultAccess", resultAccess)
        } catch (e) {
            // showErrorNotification('error getting user modules...', e)
        }
    }).catch((e) => {
        // showErrorNotification('failed to get user modules..login again.', e)
    })

    try {
        let isEnabled = await checkSettings("SCREEN_RECORD_REPORT")
        console.log("SCREEN_RECORD_REPORT isEnabled", isEnabled)
        if (isEnabled && (isEnabled === true || isEnabled === "true")) {
            localStorage.setItem('ah,bkbd^cjn', "tryruiswjrbkj");
        } else {
            localStorage.setItem('ah,bkbd^cjn', generateFourLetterRandomString());
        }
    } catch (e) {
        localStorage.setItem('ah,bkbd^cjn', generateFourLetterRandomString());
    }

    try {
        let isPriReportEnabled = await checkSettings("PRI_REPORT")
        if (isPriReportEnabled && (isPriReportEnabled === true || isPriReportEnabled === "true")) {
            localStorage.setItem('pri_report_key', "pri_report_granted");
        } else {
            localStorage.setItem('pri_report_key', generateFourLetterRandomString());
        }
    } catch (e) {
        localStorage.setItem('pri_report_key', generateFourLetterRandomString());
    }

    try {
        let isTrunkUtilReportEnabled = await checkSettings("TRUNK_UTIL_REPORT")
        if (isTrunkUtilReportEnabled && (isTrunkUtilReportEnabled === true || isTrunkUtilReportEnabled === "true")) {
            localStorage.setItem('trunk_util_report_key', "trunk_util_report_granted");
        } else {
            localStorage.setItem('trunk_util_report_key', generateFourLetterRandomString());
        }
    } catch (e) {
        localStorage.setItem('trunk_util_report_key', generateFourLetterRandomString());
    }

    try {
        let isCheckpointFlowEnabled = await checkSettings("CUST_JRNY_FLOW")
        if (isCheckpointFlowEnabled && (isCheckpointFlowEnabled === true || isCheckpointFlowEnabled === "true")) {
            localStorage.setItem('checkpoint_flow_report_key', "checkpoint_flow_report");
        } else {
            localStorage.setItem('checkpoint_flow_report_key', generateFourLetterRandomString());
        }
    } catch (e) {
        localStorage.setItem('checkpoint_flow_report_key', generateFourLetterRandomString());
    }

    try {
        let isBargeInReportEnabled = await checkSettings("BARGEIN_REPORT")
        if (isBargeInReportEnabled && (isBargeInReportEnabled === true || isBargeInReportEnabled === "true")) {
            localStorage.setItem('barge_in_report_key', "barge_in_report_granted");
        } else {
            localStorage.setItem('barge_in_report_key', generateFourLetterRandomString());
        }
    } catch (e) {
        localStorage.setItem('barge_in_report_key', generateFourLetterRandomString());
    }

    localStorage.setItem('ivr_access_key', generateFourLetterRandomString());

    await getSettingsListByCode({ isAdmin: "true", settingsCode: "PRE_POST_CALL_FLOW" }).then((resp) => {
        try {
            if (resp.Data.length > 0 || resp.Data !== null) {
                let data = resp.Data[0];
                if (data.ParameterValue === null) {
                    if (data.DefaultValue === false || data.DefaultValue === 'false') {
                        // sessionStorage.setItem(`settings_${data.ParameterCode}`, false);
                    }
                } else if (data.ParameterValue !== null) {
                    if (data.ParameterValue === true || data.ParameterValue === 'true') {
                        // sessionStorage.setItem(`settings_${data.ParameterCode}`, true);
                        finalPages.push(AdminPages.PREPOST_VIEW)
                        finalPages.push(AdminPages.PREPOST_EDIT)
                    } else if (data.ParameterValue === false || data.ParameterValue === 'false') {
                        // sessionStorage.setItem(`settings_${data.ParameterCode}`, false);
                    }
                }
                localStorage.setItem('authPages', JSON.stringify(finalPages))
            }
            else {
                showErrorNotification('user Settings list is empty....')
            }
        } catch (e) {
            showErrorNotification('error getting user settings...', e)
        }
    }).catch((e) => {
        showErrorNotification('failed to get user settings..login again.', e)
    });

}

export const syncLoggedInUserEmail = (res) => {
    let response = res;
    try {
        response = { ...res }
        if (response?.Status !== 'Success') {
            return response;
        }
        const email = response?.Data?.[0]?.email;
        if (typeof email === 'string' && email.trim()) {
            setUserEmail(email);
            cacheSlashcallSuperAdminEmail(email, checkRoles('ROLE_SLASHCALL'));
        }
        return response;
    } catch (error) {
        return response;
    }
};


export function authPage(page) {
    try {
        let authPages = JSON.parse(localStorage.getItem('authPages')) || finalPages
        return authPages.includes(page)
    }
    catch (e) {
        console.log("Can't able to find user modules value from session storage", e)
    }
}

export function getAccess(type) {
    if (type === 'View' || type === 'viewAccess') {
        // return 'viewAccess';
        return '$v*A@#';
    } else if (type === 'Edit' || type === 'editAccess') {
        // return 'editAccess';
        return '^e@@A*';
    } else if (type === 'Full' || type === 'fullAccess') {
        // return 'fullAccess';
        return '@f&A@*';
    } else if (type === 'data' || type === 'dataUpload') {
        // return 'dataUpload';
        return '*d%%U##';
    } else if (type === true) {
        return true;
    } else if (type === false) {
        return false;
    } else if (type === 'liveReports') {
        return '@l*A@#';
    } else if (type === 'historicReports') {
        return '@h*A@#';
    }

}


export function newAuthSubAdminAccess(page, accessType) {
    try {
        let authPages = JSON.parse(localStorage.getItem('newAuthSubAdminAccess')) || finalPages;
        let access = getAccess(accessType);
        return authPages.includes(`${page}_${access}`);
    }
    catch (e) {
        console.log("Can't able to find user modules value from local storage", e)
    }
}

export function getSubAdminBooleanAccess(page, defaultValue = true) {
    try {
        const hasTrueAccess = newAuthSubAdminAccess(page, true);
        const hasFalseAccess = newAuthSubAdminAccess(page, false);

        if (hasTrueAccess) {
            return true;
        }

        if (hasFalseAccess) {
            return false;
        }

        return defaultValue;
    }
    catch (e) {
        console.log("Can't able to evaluate sub admin boolean access from local storage", e);
        return defaultValue;
    }
}

export function newAuthPages(page) {
    try {
        let authPages = JSON.parse(localStorage.getItem('newAuthPage')) || finalPages;
        if (authPages.includes(page)) {
            return authPages.includes(page);
        } else {
            return false;
        }
    }
    catch (e) {
        console.log("Can't able to find user modules value from local storage", e, page);
    }
}

// Funtion ot filter reports based on roles
function getReportsByRoleAndId(reports, rolesIdMap) {
    if (!reports || !rolesIdMap || typeof reports !== 'object' || typeof rolesIdMap !== 'object') return reports;
    if (Array.isArray(reports) && reports.length > 0) {
        try {
            return reports?.filter(report => {
                if (rolesIdMap[report?.id]) {
                    return checkRoles(rolesIdMap[report?.id]?.role)
                }
                return true;
            });
        } catch (e) {
            console.log("Error in getReportsByRoleAndId", e)
            return reports;
        }
    }
    return reports;
}

function getReportsByRuleAndId(reports, rulesIdMap) {
    if (!reports || !rulesIdMap || typeof reports !== 'object' || typeof rulesIdMap !== 'object') return reports;
    if (Array.isArray(reports) && reports.length > 0) {
        try {
            return reports?.filter(report => {
                if (rulesIdMap[report?.id]) {
                    return rulesIdMap[report?.id]?.rule()
                }
                return true;
            });
        } catch (e) {
            console.log("Error in getReportsByRuleAndId", e)
            return reports;
        }
    }
    return reports;
}

// Function to get accessible live reports
export function getAccessibleLiveReports(reports = null) {
    if (reports === null) {
        reports = LIVE_REPORTS_LIST;
    }
    reports = getReportsByRoleAndId(reports, LIVE_REPORTS_LIST_ROLES_ID_MAP)
    reports = getReportsByRuleAndId(reports, LIVE_REPORTS_LIST_RULES_ID_MAP)
    if (checkRoles('ROLE_ADMIN') || (newAuthPages(NewAdminPages.LIVE_REPORTS)) || newAuthSubAdminAccess(NewAdminPages.LIVE_REPORTS, true)) {
        return reports;
    }
    return reports.filter(report => newAuthSubAdminAccess(report.id, 'liveReports'));
}

// Function to check if any live reports are accessible
export function hasAnyLiveReportAccess(reports = null) {
    if (reports === null) {
        reports = LIVE_REPORTS_LIST;
    }
    reports = getReportsByRoleAndId(reports, LIVE_REPORTS_LIST_ROLES_ID_MAP)
    reports = getReportsByRuleAndId(reports, LIVE_REPORTS_LIST_RULES_ID_MAP)
    if (checkRoles('ROLE_ADMIN') || (newAuthPages(NewAdminPages.LIVE_REPORTS)) || newAuthSubAdminAccess(NewAdminPages.LIVE_REPORTS, true)) {
        return true;
    }
    return reports.some(report => newAuthSubAdminAccess(report.id, 'liveReports'));
}

// Function to get accessible historic reports
export function getAccessibleHistoricReports(reports = null) {
    if (reports === null) {
        reports = HISTORIC_REPORTS_LIST;
    }
    reports = getReportsByRoleAndId(reports, HISTORIC_REPORTS_LIST_ROLES_ID_MAP)
    reports = getReportsByRuleAndId(reports, HISTORIC_REPORTS_LIST_RULES_ID_MAP)
    if (checkRoles('ROLE_ADMIN') || (newAuthPages(NewAdminPages.HISTORIC_REPORTS)) || newAuthSubAdminAccess(NewAdminPages.HISTORIC_REPORTS, true)) {
        return reports;
    }
    return reports.filter(report => newAuthSubAdminAccess(report.id, 'historicReports'));
}

// Function to check if any historic reports are accessible
export function hasAnyHistoricReportAccess(reports = null) {
    if (reports === null) {
        reports = HISTORIC_REPORTS_LIST;
    }
    reports = getReportsByRoleAndId(reports, HISTORIC_REPORTS_LIST_ROLES_ID_MAP)
    reports = getReportsByRuleAndId(reports, HISTORIC_REPORTS_LIST_RULES_ID_MAP)
    if (checkRoles('ROLE_ADMIN') || (newAuthPages(NewAdminPages.HISTORIC_REPORTS)) || newAuthSubAdminAccess(NewAdminPages.HISTORIC_REPORTS, true)) {
        return true;
    }
    return reports.some(report => newAuthSubAdminAccess(report.id, 'historicReports'));
}

export function writeAccess() {
    if (checkRoles('ROLE_ADMIN')) {
        return !checkRoles('ROLE_READ_ONLY');
    }
    return true;
}

export function getLocationFromProperties() {
    try {
        let location = LOCATION;
        if (location && typeof location === 'string') return location.toLowerCase();
        return '';
    } catch (e) {
        console.log("Error in getLocationFromProperties", e)
        return '';
    }
}
